import { SelectOption } from '@synqo/frontend-component-library';
import { EnumPartnershipType } from './Generated';

export function getPartnershipTypeDisplay(type: EnumPartnershipType) {
    switch (type) {
        case EnumPartnershipType.Internal:
            return 'Interner Benutzer';
        case EnumPartnershipType.Portal:
            return 'Portal-Nutzer';
    }
}

export function getPartnershipTypeShortLabel(type: EnumPartnershipType) {
    switch (type) {
        case EnumPartnershipType.Internal:
            return 'Intern';
        case EnumPartnershipType.Portal:
            return 'Portal';
    }
}

export const partnershipOptions: SelectOption<EnumPartnershipType>[] = [
    {
        name: 'internal',
        value: EnumPartnershipType.Internal,
        label: getPartnershipTypeDisplay(EnumPartnershipType.Internal),
    },
    { name: 'portal', value: EnumPartnershipType.Portal, label: getPartnershipTypeDisplay(EnumPartnershipType.Portal) },
];
